import React, { useEffect } from "react";
import "../App.scss";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";
import { useDispatch, useSelector } from "react-redux";
import { footerDisplaying } from "../store/mainSlice";
import MastercardNew from "../img/svg/Mastercard_new.svg";
import { Radio } from "@mui/material";
import { useTranslation } from "react-i18next";
import { isPartnerClalit } from "../store/partnerStore";

export default function RemainedCard({
  isOpen,
  setIsOpen,
  // onChangeLogic,
  // last4Digit,
  selectedClub,
}) {
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const isClalit = useSelector(isPartnerClalit);

  useEffect(() => {
    dispatch(footerDisplaying(true));
    return () => {
      dispatch(footerDisplaying(false));
    };
  }, []);

  return (
    <div>
      {isOpen && (
        <div className={`bottom-popup`}>
          <div className="popup-content">
            <div
              className="popup-content-wrapper"
              // style={{
              //   // display: "flex",
              //   // flexDirection: "column",
              //   justifyContent: "space-between",
              //   flexGrow:1
              // }}
            >
              <div>
                <div className="mobile-popup-header">
                  <IconButton
                    aria-label="close"
                    onClick={() => setIsOpen(false)}
                    sx={(theme) => ({
                      color: "var(--darkblue)",
                    })}
                  >
                    <CloseIcon />
                  </IconButton>
                  <p className="mobile-popup-header-text">{t("REMAINED_CARD.PURCHASE_SUMMARY")}</p>
                  <span className="mobile-popup-header-close-btn"></span>
                </div>
                <div className={isClalit ? "mobile-popup-header-info" : "mobile-popup-header-info-wow"}>
                  {selectedClub.Name}
                  <p>
                    {t("ON_DATE")} 09/06/24 {t("AT_TIME")}10:00
                  </p>
                </div>
              </div>
              <div className="mobile-popup-content-wrapper">
                {}
                {/*<iframe
                src=""
                frameborder="0"
                className="mobile-popup-content-iframe"
              ></iframe>*/}
                <div className="mobile-popup-text-content-container">
                  <div className="mobile-popup-payment-method-container">
                    <div className="mobile-popup-card-number">
                      <span className="card-dots">●●●●</span>
                      {/* <span className="card-number">{last4Digit}</span> */}
                      <img src={MastercardNew} alt="" className="card-logo" />
                    </div>
                    <div className="radio-btn-container">
                      <p className="credit-card">{t("REMAINED_CARD.CREDIT_CARD")}</p>
                      <Radio />
                    </div>
                  </div>

                  <div className="mobile-popup-text-footer">
                    <p className="mobile-popup-text-thin">{t("REMAINED_CARD.TOTAL_PRICE")}:</p>
                    {selectedClub.Price > 0 && <p>₪{selectedClub.Price}</p>}
                  </div>
                </div>
              </div>
            </div>
            <div className="mobile-popup-btn-block">
              <button
                style={{ fontSize: "18px", fontWeight: 700 }}
                className={isClalit ? "main-page-btn big-button very-big-button lightred-btn" : "payment-button-wow"}
                // onClick={onChangeLogic}
              >
                {t("REMAINED_CARD.PAY")}
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
